import React from 'react';

import Header from './partials/Header';
    import Banner from './assessment/Banner';
    import NameAge from './assessment/NameAge';
    import FeelInMorning from './assessment/FeelInMorning';
    import SkinConcerns from './assessment/SkinConcerns';
    import Ingredients from './assessment/Ingredients';
    import Apply from './assessment/Apply';
    import Email from './assessment/Email';
import Footer from './partials/Footer';

function Assessment() {
  return (
    <div className="Assessment">
        <Header/>
            <Banner/>
            <NameAge/>
            <FeelInMorning/>
            <SkinConcerns/>
            <Ingredients/>
            <Apply/>
            <Email/>
        <Footer/>
    </div>
  );
}

export default Assessment;
